import _ from 'lodash';
import OPERATORS from '../constants/operators';

const operatorMap = {
  [OPERATORS.EQUALS]: (value, num) => value === num,
  [OPERATORS.GREATER_THAN]: (value, num) => value > num,
  [OPERATORS.GREATER_THAN_EQUAL_TO]: (value, num) => value >= num,
  [OPERATORS.SMALLER_THAN]: (value, num) => value < num,
  [OPERATORS.SMALLER_THAN_EQUAL_TO]: (value, num) => value <= num,
  [OPERATORS.BETWEEN]: (value, start, end) => value >= start && value <= end,
};
const numberMultilineGroupedFilterMethod = (filter, rowOrRowValue) => {
  const {
    operator,
    number,
    endNumber,
    multiSelectValues,
    clearFilter,
  } = filter.value;
  if (clearFilter) {
    return true;
  }

  let rowValue;
  if (rowOrRowValue) {
    rowValue = rowOrRowValue[filter.id] ? rowOrRowValue[filter.id] : rowOrRowValue;
  } else {
    rowValue = rowOrRowValue;
  }

  if (!Array.isArray(rowValue)) {
    rowValue = Array.from([rowValue]);
  }

  const markedRowValues = [];
  const multiSelectCriteria = multiSelectValues && multiSelectValues.length;
  rowValue.forEach((v) => {
    if (multiSelectCriteria) {
      markedRowValues.push({ multiSelectValues: [...multiSelectValues.map(msv => msv.value)], value: v, result: _.some(multiSelectValues, { value: v === undefined ? null : v }) });
    }
    if (number) {
      markedRowValues.push({
        start: number, end: endNumber, value: v, result: !operatorMap[operator] || operatorMap[operator](v, number, endNumber),
      });
    }
  });

  return markedRowValues.some(markedRowValue => markedRowValue.result);
};

export default numberMultilineGroupedFilterMethod;
